import API from '@/config/api';
import Request from '@/config/request'; // 封装的axips
import http from '@/config/http';  //原来的axios
export default {
    async loginIn(data){
        let d = await Request.get('get', API.login.login,data)
        return d
    },
     Handlenoncestr() {
    let str = "",

            arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
                'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G',
                'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
            ];

        // 随机产生，i为指定长度

        for (let i = 0; i < 30; i++) {
            let pos = Math.round(Math.random() * (arr.length - 1));
            str += arr[pos];
        }
        return str;
    },
    obtainUrlWXCode:function(){
        let urlParams = location.search;
        let arr = urlParams.split('?')
        console.log(arr,'5444');
        if(arr.length<=1){
            return
        }
        let paramsArr =  (arr[1]).split('&');
        let paramsObj = {};
        for(let item of paramsArr){
            paramsObj[item.split('=')[0]] = item.split('=')[1];
        }
        console.log(paramsObj,'paramsObj');
        return paramsObj.code
    },
    funcUrlDel(name){
        var loca = window.location;
        var baseUrl = loca.origin + loca.pathname + "?";
        var query = loca.search.substr(1);
        if (query.indexOf(name)>-1) {
            var obj = {}
            var arr = query.split("&");
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].split("=");
                obj[arr[i][0]] = arr[i][1];
            };
            delete obj[name];
            var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
            return url
        }else {
            return window.location.href
        }
    },
    getCookie: (name) => {//获取cookie
        // let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        // if (arr = document.cookie.match(reg)) {
        //   return (unescape(arr[2]));
        // } else {
        //   return null;
        // }
        let str = sessionStorage.getItem(name)
        if(str){
            return str
        }else{
            return null;
        }
    },
    setCookie: (c_name, value, expiredays) => {//设置cookie,增加到vue实例方便全局调用
        sessionStorage.setItem(c_name, value)
        // let exdate = new Date();
        // exdate.setDate(exdate.getDate() + expiredays);
        // document.cookie = c_name + "=" + escape(value) + ';path=/;secure:true;' + ((expiredays == null) ? "" : ";expires=" +
        //   exdate.toGMTString());
    },
    delCookie: (name) => {//删除cookie
        // setCookie(name, "", -1);
        // $this.$config.setCookie(name, "", -1);
        sessionStorage.removeItem(name)
    },
    getBase64(imgUrl) {
        window.URL = window.URL || window.webkitURL;
        return new Promise((resolve, reject) => {
            window.URL = window.URL || window.webkitURL;
            var xhr = new XMLHttpRequest();
            xhr.open("get", imgUrl, true);
            xhr.responseType = "blob";
            xhr.onload = function(){
                if(xhr.status == 200){
                    //得到一个blob对象
                    var blob = this.response;
                    console.log("blob", blob)
                    // 至关重要
                    let oFileReader = new FileReader();
                    oFileReader.onloadend = function(e){
                        // 此处拿到的已经是base64的图片了,可以赋值做相应的处理
                        // console.log(e.target.result)
                        resolve(e.target.result)
                    }
                    oFileReader.readAsDataURL(blob);
                }
            }
            xhr.send();
        }).catch(err=>{
            console.log(err,'32323232')
        })
    },
    async wxLogin($this){
        let code = this.obtainUrlWXCode();
        let {
            query,
            path
        } = $this.$route;
        console.log(query, 'query', path);
        console.log(code,'code')
        if (!code){
            let authorizeLoginUrl = '';
            let wxDomainName = 'https://open.weixin.qq.com/connect/oauth2/authorize?';
            let appid = 'appid=wxb2e185540e02d9be'; //公众号的唯一标识  weiji
            // let appid = 'appid=wx56ad6d13441ed8d7'; //公众号的唯一标识   锐景
            //wx56ad6d13441ed8d7('锐景 = 开放平台')->wxb2efb86eaa1d7cef ('苏州银行')   wx7c54e3e6996fa6e7  第三方平台appid
            let component_appid = '&component_appid=wx7c54e3e6996fa6e7' //第三方平台appid
            console.log(window.location.href);

            // return
            let url=location.href;
            console.log(url,'url!!!!')
            // return
            // let url=location.href.includes('detail')?location.href:location.href.split('?')[0];
            let redirect_uri = '&redirect_uri=' + url; //授权后重定向的回调链接地址， 请使用 urlEncode 对链接进行处理

            let response_type = "&response_type=code";//返回类型，请填写code
            let scope = "&scope=snsapi_userinfo,snsapi_base";//应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
            let state = `&state=232`;//重定向后会带上state参数，开发者可以填写a-zA-Z0-9的参数值，最多128字节
            let connect_redirect = "&connect_redirect=1";//授权两次重定向
            let wechat_redirect ="#wechat_redirect";//无论直接打开还是做页面302重定向时候，必须带此参数

            authorizeLoginUrl = wxDomainName + appid + component_appid + redirect_uri + response_type + scope + state + connect_redirect + wechat_redirect;



            console.log(authorizeLoginUrl);
            $this.isLogin = false;
            // return
            window.location.href = authorizeLoginUrl;
        } else {
            // dyw-大洋湾/dthhsl-黄海森林/tongde-同德/ycjc-盐城公安/sheyang-射阳文旅/qdnsh-启东农商行/rj-锐景创意
            // szyh 苏州银行
            // let res = await http.get(API.login.login + '?code=' + code + '&penguinUser=rj')
            let res = await http.get(API.login.login + '?code=' + code + '&penguinUser=wj')
            // $this.isLogin = true;

            // let authorization = res.headers['authorization'];
            console.log('成功成功！！！！')
            sessionStorage.setItem('headimgurl', res.data.headimgurl)
            sessionStorage.setItem('nickname', res.data.nickname)
            // return authorization
            if (/android/i.test(navigator.userAgent)) {
                console.log("Android"); //Android
                $this.$router.replace(path)
            }
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                console.log("iOS"); //iOS
                $this.$router.replace(path)
                // location.href='https://h5.risvion.com/wj/milk'+path
            }
        }
    },
    wxShare(title,des,$this){
        let this_= this;
        var str = window.location.href.toString()
        if (str.substr(str.length - 1, 1) == '/') {
            str = str.substr(0, str.length - 1)
        }
        var param = {
            noncestr: this.Handlenoncestr(), //生成签名的随机串
            url: str, //分享的文章地址
            // penguinUser: "rj",
            penguinUser: "wj",
        }
        // dyw-大洋湾/dthhsl-黄海森林/tongde-同德/ycjc-盐城公安/sheyang-射阳文旅/qdnsh-启东农商行/rj-锐景创意
        // szyh 苏州银行
        //wx56ad6d13441ed8d7('锐景 = 开放平台')->wxb2efb86eaa1d7cef ('苏州银行')   wx7c54e3e6996fa6e7  第三方平台appid
        http.post('https://penguinkf.risvion.com/api/wechat/getSignature', param).then(res=>{
            // http.post('https://h5.risvion.com/api/wechat/getSignature', param).then(res=>{
            console.log(res,'share')
            wx.config({
                debug: false,
                appId: 'wxb2e185540e02d9be', //wx56ad6d13441ed8d7('锐景')->wxb2efb86eaa1d7cef ('苏州银行')
                timestamp: res.data.timestamp,
                nonceStr: param.noncestr,
                signature: res.data.signature,
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage',
                    'onMenuShareTimeline','chooseImage','getLocalImgData'
                ]
            });
            wx.ready(function() {
                console.log('success')
                wx.updateAppMessageShareData({ //分享给朋友　　
                    title: title,
                    desc: des,
                    link: this_.funcUrlDel('code'),
                    imgUrl: require('../../public/guangming_milk/share/share.jpg'),
                    type: 'link',
                    success: function() {
                    },
                    cancel: function() {
                    }
                });
                wx.updateTimelineShareData({ //分享朋友圈　
                    title: title,
                    desc: des,
                    link: this_.funcUrlDel('code'), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: require('../../public/guangming_milk/share/share.jpg'), // 分享图标
                    success: function() {
                    },
                    cancel: function() {
                    }
                });
                wx.onMenuShareTimeline({ //分享到朋友圈即将废弃
                    title: title,
                    desc: des,
                    link: this_.funcUrlDel('code'),
                    imgUrl: require('../../public/guangming_milk/share/share.jpg'), // 分享图标
                    //                  type: 'link',
                    success: function() {},
                    cancel: function() {
                    }
                });
                wx.onMenuShareAppMessage({ //分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
                    title: title,
                    desc: des,
                    link: this_.funcUrlDel('code'),
                    imgUrl: require('../../public/guangming_milk/share/share.jpg'), // 分享图标
                    type: 'link', // 分享类型,music、video或link，不填默认为link
                    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                    success: function() {
                    },
                    cancel: function() {
                    }
                });

            })
            wx.error(function(res) {
                console.log(res,'fail!!!error')
                // log('验证失败返回的信息:', res)
            });
        }).catch(err=>{
            console.log(err,'err')
        })

    }

}
